// Mirrors `ClerkOfflineError.is` from @clerk/shared, which is not a direct dependency.
// Clerk Core 3 throws this from `session.getToken()` when the browser is offline.
const CLERK_OFFLINE_ERROR_CODE = 'clerk_offline'

export const isClerkOfflineError = (error: unknown): boolean =>
  typeof error === 'object' && error !== null && (error as { code?: unknown }).code === CLERK_OFFLINE_ERROR_CODE
